import { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Grid,
  GridItem,
  useColorModeValue,
  Button,
  Input,
  Textarea,
  Select,
  Switch,
  FormControl,
  FormLabel,
  VStack,
  HStack,
  Heading,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Spinner,
  Divider,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Wrap,
  WrapItem,
  Tag,
  TagLabel,
  TagCloseButton,
} from "@chakra-ui/react";
import { FaCog, FaSave, FaBell, FaShieldAlt, FaPlus, FaAnchor } from "react-icons/fa";
import { useQuery, useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { addHolidayDate, deleteHolidayDate, getSetting, UpdateSetting } from "../services/settingService"; // مسیر سرویس را وارد کنید
import JalaliDatePicker from "../components/JalaliDatePicker";
import moment from 'moment-jalaali';

function Settings() {
  const textColor = useColorModeValue("gray.700", "white");
  const bgCard = useColorModeValue("white", "gray.700");
  const queryClient = useQueryClient();
// State برای تاریخ انتخاب‌شده (میلادی)
const [selectedHolidayDate, setSelectedHolidayDate] = useState(null);
// State برای لیست تاریخ‌های تعطیل (از سرور پر می‌شود)
const [holidayDates, setHolidayDates] = useState([]);  

  // State برای تنظیمات
  const [generalSettings, setGeneralSettings] = useState({
    clinicName: '',
    clinicAddress: '',
    clinicPhone: '',
    clinicPhone2: '',
    clinicEmail: '',
    workingHours: '',
    disabledClinic: false,
    terms: '',
    showBookingSessionDuration: true,
    showBookingSessionCost: true,
  });

  const [notificationSettings, setNotificationSettings] = useState({
    emailNotifications: false,
    smsNotifications: true,
    appointmentReminders: true,
    reminderTime: 20,
    paymentReminders: true,
    reminderPaymentReminders: 16,
    appointmentCancelled: true,
    reimderOfAppointmentCancelled: 18,
    systemUpdates: false,
    reminderMethod: 'sms'
  });

  const [securitySettings, setSecuritySettings] = useState({
    twoFactorAuth: false,
    sessionTimeout: '30',
    passwordExpiry: '90',
    loginAttempts: '5',
    ipWhitelist: '',
    auditLog: true
  });

  // دریافت تنظیمات از API با استفاده از سرویس
  const {
    data,
    isLoading,
    error,
    isFetching
  } = useQuery(
    ['settings'],
    async () => {
      const response = await getSetting();
      return response.data;
    },
    {
      keepPreviousData: true,
      staleTime: 10 * 60 * 1000, // 10 دقیقه
      onSuccess: (data) => {
        if (data?.general) {
        setGeneralSettings(prev => ({ ...prev, ...data.general }));
        // ست کردن تاریخ‌های تعطیل از data.general.holidayDates
        setHolidayDates(data.general.holidayDates || []);
      }
        if (data?.notifications) setNotificationSettings(prev => ({ ...prev, ...data.notifications }));
        if (data?.security) setSecuritySettings(prev => ({ ...prev, ...data.security }));

      },
      onError: (error) => {
        toast.error(error.message || 'خطا در دریافت تنظیمات');
      }
    }
  );
const handleAddHoliday = () => {
  if (!selectedHolidayDate) {
    toast.error('لطفاً یک تاریخ انتخاب کنید');
    return;
  }
  let dateObj;
  if (selectedHolidayDate instanceof Date) {
    dateObj = selectedHolidayDate;
  } else {
    dateObj = new Date(selectedHolidayDate);
  }
  if (isNaN(dateObj.getTime())) {
    toast.error('تاریخ نامعتبر است');
    return;
  }
  // تنظیم به نیمه شب UTC برای جلوگیری از مشکلات منطقه زمانی
  const utcDate = new Date(Date.UTC(
    dateObj.getUTCFullYear(),
    dateObj.getUTCMonth(),
    dateObj.getUTCDate()
  ));
  const isoDate = utcDate.toISOString();
  addHolidayMutation.mutate({ date: isoDate });
};

const handleDeleteHoliday = (dateToDelete) => {
  let dateObj;
  if (dateToDelete instanceof Date) {
    dateObj = dateToDelete;
  } else {
    dateObj = new Date(dateToDelete);
  }
  if (isNaN(dateObj.getTime())) return;
  const utcDate = new Date(Date.UTC(
    dateObj.getUTCFullYear(),
    dateObj.getUTCMonth(),
    dateObj.getUTCDate()
  ));
  const isoDate = utcDate.toISOString();
  deleteHolidayMutation.mutate({ date: isoDate });
};
  // Mutation برای افزودن تاریخ تعطیل
const addHolidayMutation = useMutation(
  async (date) => {
    return await addHolidayDate(date);
  },
  {
    onSuccess: (data) => {
      toast.success(data.message || 'تاریخ با موفقیت اضافه شد');
      // به‌روزرسانی لیست محلی
      if (data.holidayDates) {
        setHolidayDates(data.holidayDates);
      }
      // invalidate کش کوئری settings (اختیاری)
      queryClient.invalidateQueries(['settings']);
      setSelectedHolidayDate(null); // پاک کردن انتخاب
    },
    onError: (error) => {
      toast.error(error.message || 'خطا در افزودن تاریخ تعطیل');
    }
  }
);

// Mutation برای حذف تاریخ تعطیل
const deleteHolidayMutation = useMutation(
  async (date) => {
    return await deleteHolidayDate(date);
  },
  {
    onSuccess: (data) => {
      toast.success(data.message || 'تاریخ با موفقیت حذف شد');
      if (data.holidayDates) {
        setHolidayDates(data.holidayDates);
      }
      queryClient.invalidateQueries(['settings']);
    },
    onError: (error) => {
      toast.error(error.message || 'خطا در حذف تاریخ تعطیل');
    }
  }
);

  // Mutation برای ذخیره تنظیمات با استفاده از سرویس
  const saveSettingsMutation = useMutation(
    async (settings) => {
      return await UpdateSetting(settings);
    },
    {
      onSuccess: (data) => {
        toast.success(data.message || 'تنظیمات با موفقیت ذخیره شد');
        queryClient.invalidateQueries(['settings']);
      },
      onError: (error) => {
        toast.error(error.message || 'خطا در ذخیره تنظیمات');
      }
    }
  );

  // تابع ذخیره تنظیمات عمومی
  const handleSaveGeneralSettings = () => {
    saveSettingsMutation.mutate({ general: generalSettings });
  };

  // تابع ذخیره تنظیمات اعلان‌ها
  const handleSaveNotificationSettings = () => {
    saveSettingsMutation.mutate({ notifications: notificationSettings });
  };

  // تابع ذخیره تنظیمات امنیت
  const handleSaveSecuritySettings = () => {
    saveSettingsMutation.mutate({ security: securitySettings });
  };

  // اگر در حال بارگذاری است
  if (isLoading) {
    return (
      <Flex direction="column" pt={{ base: "120px", md: "75px" }} dir="rtl">
        <Box mx="auto" p={{ base: "20px", md: "30px" }} pe="20px" minH="100vh">
          <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
            <Flex justify="center" align="center" minH="400px">
              <Spinner size="xl" color="teal.500" />
              <Text mr={4} fontSize="lg" color={textColor}>
                در حال بارگذاری تنظیمات...
              </Text>
            </Flex>
          </Box>
        </Box>
      </Flex>
    );
  }

  // اگر خطا رخ داده است
  if (error) {
    return (
      <Flex direction="column" pt={{ base: "120px", md: "75px" }} dir="rtl">
        <Box mx="auto" p={{ base: "20px", md: "30px" }} pe="20px" minH="100vh">
          <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              <AlertTitle>خطا در بارگذاری تنظیمات!</AlertTitle>
              <AlertDescription>
                {error.message || 'خطا در ارتباط با سرور'}
              </AlertDescription>
            </Alert>
            <Button
              mt={4}
              colorScheme="teal"
              onClick={() => queryClient.invalidateQueries(['settings'])}
              isLoading={isFetching}
            >
              تلاش مجدد
            </Button>
          </Box>
        </Box>
      </Flex>
    );
  }

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} dir="rtl">
      <Box mx="auto" p={{ base: "20px", md: "30px" }} pe="20px" minH="100vh">
        <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
          <Box p="20px 0px 35px 0px">
            <Flex direction="column">
              <Text fontSize="lg" color={textColor} fontWeight="bold" me="auto">
                تنظیمات سیستم
              </Text>
              <Text fontSize="md" fontWeight="400" me="auto" color="gray.400">
                مدیریت تنظیمات کلینیک و سیستم
              </Text>
            </Flex>
          </Box>

          <Grid templateColumns={{ base: "1fr", lg: "repeat(2, 1fr)" }} gap={6} px="25px">
            {/* تنظیمات عمومی */}
            <GridItem>
              <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
                <Box mb="20px">
                  <HStack spacing={3}>
                    <FaCog color="teal" />
                    <Heading size="md" color={textColor}>تنظیمات عمومی</Heading>
                  </HStack>
                </Box>
                <Box>
                  <VStack spacing={4} align="stretch">
                    <FormControl>
                      <FormLabel>نام کلینیک</FormLabel>
                      <Input
                        value={generalSettings.clinicName}
                        onChange={(e) => setGeneralSettings({...generalSettings, clinicName: e.target.value})}
                        placeholder="نام کلینیک"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>آدرس کلینیک</FormLabel>
                      <Textarea
                        value={generalSettings.clinicAddress}
                        onChange={(e) => setGeneralSettings({...generalSettings, clinicAddress: e.target.value})}
                        placeholder="آدرس کامل کلینیک"
                        rows={3}
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>شماره تماس اصلی</FormLabel>
                      <Input
                        value={generalSettings.clinicPhone}
                        onChange={(e) => setGeneralSettings({...generalSettings, clinicPhone: e.target.value})}
                        placeholder="شماره تماس"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>شماره تماس دوم</FormLabel>
                      <Input
                        value={generalSettings.clinicPhone2}
                        onChange={(e) => setGeneralSettings({...generalSettings, clinicPhone2: e.target.value})}
                        placeholder="شماره تماس دوم"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>ایمیل</FormLabel>
                      <Input
                        value={generalSettings.clinicEmail}
                        onChange={(e) => setGeneralSettings({...generalSettings, clinicEmail: e.target.value})}
                        placeholder="ایمیل کلینیک"
                        type="email"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>ساعات کاری</FormLabel>
                      <Input
                        value={generalSettings.workingHours}
                        onChange={(e) => setGeneralSettings({...generalSettings, workingHours: e.target.value})}
                        placeholder="ساعات کاری"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>قوانین و مقررات</FormLabel>
                      <Textarea
                        value={generalSettings.terms}
                        onChange={(e) => setGeneralSettings({...generalSettings, terms: e.target.value})}
                        placeholder="قوانین و مقررات کلینیک"
                        rows={5}
                      />
                    </FormControl>

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">غیرفعال کردن کلینیک</FormLabel>
                      <Switch
                        isChecked={generalSettings.disabledClinic}
                        onChange={(e) => setGeneralSettings({...generalSettings, disabledClinic: e.target.checked})}
                        colorScheme="teal"
                      />
                    </FormControl>
                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0"> بستن ثبت نام جدید </FormLabel>
                      <Switch
                        isChecked={generalSettings.disabledRgistration}
                        onChange={(e) => setGeneralSettings({...generalSettings, disabledRgistration: e.target.checked})}
                        colorScheme="teal"
                      />
                    </FormControl>

                    <Divider />
                    <Text fontSize="sm" color="gray.500">
                      تنظیمات نمایش در صفحه رزرو نوبت توسط مراجع (بیعانه را تحت‌تأثیر قرار نمی‌دهد)
                    </Text>

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">نمایش «مدت جلسه» در رزرو</FormLabel>
                      <Switch
                        isChecked={generalSettings.showBookingSessionDuration !== false}
                        onChange={(e) => setGeneralSettings({...generalSettings, showBookingSessionDuration: e.target.checked})}
                        colorScheme="teal"
                      />
                    </FormControl>

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">نمایش «هزینه جلسه» در رزرو</FormLabel>
                      <Switch
                        isChecked={generalSettings.showBookingSessionCost !== false}
                        onChange={(e) => setGeneralSettings({...generalSettings, showBookingSessionCost: e.target.checked})}
                        colorScheme="teal"
                      />
                    </FormControl>

                    <Button
                      leftIcon={<FaSave />}
                      colorScheme="teal"
                      onClick={handleSaveGeneralSettings}
                      isLoading={saveSettingsMutation.isLoading}
                    >
                      ذخیره تنظیمات عمومی
                    </Button>
                  </VStack>
                </Box>
              </Box>
            </GridItem>

            {/* تنظیمات اعلان‌ها */}
            <GridItem>
              <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
                <Box mb="20px">
                  <HStack spacing={3}>
                    <FaBell color="blue" />
                    <Heading size="md" color={textColor}>تنظیمات اعلان‌ها</Heading>
                  </HStack>
                </Box>
                <Box>
                  <VStack spacing={4} align="stretch">
                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">اعلان‌های ایمیل</FormLabel>
                      <Switch
                        isChecked={notificationSettings.emailNotifications}
                        onChange={(e) => setNotificationSettings({...notificationSettings, emailNotifications: e.target.checked})}
                        colorScheme="blue"
                      />
                    </FormControl>

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">اعلان‌های پیامک</FormLabel>
                      <Switch
                        isChecked={notificationSettings.smsNotifications}
                        onChange={(e) => setNotificationSettings({...notificationSettings, smsNotifications: e.target.checked})}
                        colorScheme="blue"
                      />
                    </FormControl>

                    <Divider />

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">یادآوری ملاقات‌ها</FormLabel>
                      <Switch
                        isChecked={notificationSettings.appointmentReminders}
                        onChange={(e) => setNotificationSettings({...notificationSettings, appointmentReminders: e.target.checked})}
                        colorScheme="blue"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>زمان یادآوری ملاقات (ساعت روز قبل)</FormLabel>
                    
                      <NumberInput
                        value={notificationSettings.reminderTime}
                        onChange={(val) => setNotificationSettings({...notificationSettings, reminderTime: Number(val)})}
                        min={0}
                        max={24}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>

                    <FormControl>
                      <FormLabel>روش یادآوری</FormLabel>
                      <Select
                        value={notificationSettings.reminderMethod}
                        onChange={(e) => setNotificationSettings({...notificationSettings, reminderMethod: e.target.value})}
                      >
                        <option value="sms">پیامک</option>
                        <option value="email">ایمیل</option>
                        <option value="both">هر دو</option>
                      </Select>
                    </FormControl>

                    <Divider />

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">یادآوری پرداخت</FormLabel>
                      <Switch
                        isChecked={notificationSettings.paymentReminders}
                        onChange={(e) => setNotificationSettings({...notificationSettings, paymentReminders: e.target.checked})}
                        colorScheme="blue"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>ساعت یادآوری پرداخت (همان روز)</FormLabel>
                      <NumberInput
                        value={notificationSettings.reminderPaymentReminders}
                        onChange={(val) => setNotificationSettings({...notificationSettings, reminderPaymentReminders: Number(val)})}
                        min={0}
                        max={24}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>

                    <Divider />

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">اطلاع‌رسانی لغو ملاقات</FormLabel>
                      <Switch
                        isChecked={notificationSettings.appointmentCancelled}
                        onChange={(e) => setNotificationSettings({...notificationSettings, appointmentCancelled: e.target.checked})}
                        colorScheme="blue"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>ساعت اطلاع‌رسانی لغو (در صورت عدم پرداخت)</FormLabel>
                      <NumberInput
                        value={notificationSettings.reimderOfAppointmentCancelled}
                        onChange={(val) => setNotificationSettings({...notificationSettings, reimderOfAppointmentCancelled: Number(val)})}
                        min={0}
                        max={24}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>

                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb="0">به‌روزرسانی‌های سیستم</FormLabel>
                      <Switch
                        isChecked={notificationSettings.systemUpdates}
                        onChange={(e) => setNotificationSettings({...notificationSettings, systemUpdates: e.target.checked})}
                        colorScheme="blue"
                      />
                    </FormControl>

                    <Button
                      leftIcon={<FaSave />}
                      colorScheme="blue"
                      onClick={handleSaveNotificationSettings}
                      isLoading={saveSettingsMutation.isLoading}
                    >
                      ذخیره تنظیمات اعلان‌ها
                    </Button>
                  </VStack>
                </Box>
              </Box>
            </GridItem>

            {/* تنظیمات امنیت */}
            <GridItem colSpan={{ base: 1, lg: 2 }}>
              <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
                <Box mb="20px">
                  <HStack spacing={3}>
                    <FaShieldAlt color="red" />
                    <Heading size="md" color={textColor}>تنظیمات امنیت</Heading>
                  </HStack>
                </Box>
                <Box>
                  <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
                    <VStack spacing={4} align="stretch">
                      <FormControl display="flex" alignItems="center">
                        <FormLabel mb="0">احراز هویت دو مرحله‌ای</FormLabel>
                        <Switch
                          isChecked={securitySettings.twoFactorAuth}
                          onChange={(e) => setSecuritySettings({...securitySettings, twoFactorAuth: e.target.checked})}
                          colorScheme="red"
                        />
                      </FormControl>

                      <FormControl>
                        <FormLabel>مدت زمان نشست (دقیقه)</FormLabel>
                        <Select
                          value={securitySettings.sessionTimeout}
                          onChange={(e) => setSecuritySettings({...securitySettings, sessionTimeout: e.target.value})}
                        >
                          <option value="15">15 دقیقه</option>
                          <option value="30">30 دقیقه</option>
                          <option value="60">1 ساعت</option>
                          <option value="120">2 ساعت</option>
                        </Select>
                      </FormControl>

                      <FormControl>
                        <FormLabel>انقضای رمز عبور (روز)</FormLabel>
                        <Select
                          value={securitySettings.passwordExpiry}
                          onChange={(e) => setSecuritySettings({...securitySettings, passwordExpiry: e.target.value})}
                        >
                          <option value="30">30 روز</option>
                          <option value="60">60 روز</option>
                          <option value="90">90 روز</option>
                          <option value="180">180 روز</option>
                          <option value="365">1 سال</option>
                        </Select>
                      </FormControl>
                    </VStack>

                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>تعداد تلاش‌های ورود</FormLabel>
                        <Select
                          value={securitySettings.loginAttempts}
                          onChange={(e) => setSecuritySettings({...securitySettings, loginAttempts: e.target.value})}
                        >
                          <option value="3">3 بار</option>
                          <option value="5">5 بار</option>
                          <option value="10">10 بار</option>
                        </Select>
                      </FormControl>

                      <FormControl>
                        <FormLabel>لیست IP مجاز (با کاما جدا کنید)</FormLabel>
                        <Input
                          value={securitySettings.ipWhitelist}
                          onChange={(e) => setSecuritySettings({...securitySettings, ipWhitelist: e.target.value})}
                          placeholder="192.168.1.1, 10.0.0.1"
                        />
                      </FormControl>

                      <FormControl display="flex" alignItems="center">
                        <FormLabel mb="0">ثبت فعالیت‌ها (Audit Log)</FormLabel>
                        <Switch
                          isChecked={securitySettings.auditLog}
                          onChange={(e) => setSecuritySettings({...securitySettings, auditLog: e.target.checked})}
                          colorScheme="red"
                        />
                      </FormControl>
                    </VStack>
                  </Grid>

                  <Box mt={6}>
                    <Button
                      leftIcon={<FaSave />}
                      colorScheme="red"
                      onClick={handleSaveSecuritySettings}
                      isLoading={saveSettingsMutation.isLoading}
                    >
                      ذخیره تنظیمات امنیت
                    </Button>
                  </Box>
                </Box>
              </Box>
            </GridItem>
            <GridItem colSpan={{ base: 1, lg: 2 }}>
    <Box bg={bgCard} borderRadius="15px" boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)" p="20px">
    <Box mb="20px">
      <HStack spacing={3}>
        <FaAnchor color="blue" />
        <Heading size="md" color={textColor}> تاریخ های تعطیل</Heading>
      </HStack>
    </Box>
    <Box>
      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
        <VStack spacing={4} align="stretch">
          <FormControl>
            <FormLabel>انتخاب تاریخ تعطیلی جدید</FormLabel>
            <JalaliDatePicker
              value={selectedHolidayDate}
              onChange={(value) => setSelectedHolidayDate(value)}
              placeholder="تاریخ تعطیلی را انتخاب کنید"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              minDate={new Date()}
            />
          </FormControl>
          <Button
            leftIcon={<FaPlus />}
            colorScheme="blue"
            onClick={handleAddHoliday}
            isLoading={addHolidayMutation.isLoading}
            isDisabled={!selectedHolidayDate}
          >
            افزودن تاریخ تعطیل
          </Button>
        </VStack>

        <VStack spacing={4} align="stretch">
          <FormLabel>لیست تاریخ‌های تعطیل ثبت شده</FormLabel>
          <Box
            border="1px solid"
            borderColor={"gray.200"}
            borderRadius="md"
            p={3}
            minH="120px"
            maxH="200px"
            overflowY="auto"
          >
            {holidayDates.length === 0 ? (
              <Text color="gray.500" textAlign="center">هیچ تاریخ تعطیلی ثبت نشده است</Text>
            ) : (
              <Wrap spacing={2}>
                {holidayDates.map((date, index) => {
                  // تبدیل تاریخ میلادی به شمسی برای نمایش
                  const jalaliDate = moment(date).format('jYYYY/jMM/jDD');
                  return (
                    <WrapItem key={index}>
                      <Tag
                        size="lg"
                        borderRadius="full"
                        variant="solid"
                        colorScheme="blue"
                      >
                        <TagLabel>{jalaliDate}</TagLabel>
                        <TagCloseButton
                          onClick={() => handleDeleteHoliday(date)}
                          isDisabled={deleteHolidayMutation.isLoading}
                        />
                      </Tag>
                    </WrapItem>
                  );
                })}
              </Wrap>
            )}
          </Box>
          {deleteHolidayMutation.isLoading && (
            <Text fontSize="sm" color="gray.500">در حال حذف...</Text>
          )}
        </VStack>
      </Grid>
    </Box>
  </Box>
</GridItem>
              
            
          </Grid>
        </Box>
      </Box>
    </Flex>
  );
}

export default Settings;